window.addEventListener("skio:plan-picker:loaded", () => {
  (window.SkioPlanPickerInstances || []).forEach((skio, i) => {
    console.log("Hooking into variant changes for instance:", i);

    const $variantInput = skio.form.querySelector(skio.selectors.variantId);

    const forceSub = () => {
      const subGroup = skio.$planPicker.querySelector('[skio-selling-plan-group]');
      if (subGroup && !subGroup.checked) {
        subGroup.checked = true;
        skio.updateSellingPlan();
        console.log("Forced subscription after variant change");
      }
    };

    // Run once immediately
    forceSub();

    // Watch for variant changes
    if ($variantInput) {
      $variantInput.addEventListener("change", forceSub);
      new MutationObserver(forceSub).observe($variantInput, {
        attributes: true,
        attributeFilter: ["value"]
      });
    }
  });
});